import { useState } from "react";
import { Link } from "react-router-dom";
import { homeFaqList } from "@/mocks/faq";
import SectionHeading from "@/components/base/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-40">
      <SectionHeading
        eyebrow="常见问题"
        title="关于站点与内容，你可能想问的"
        desc="如果这里没有解答你的疑问，可以通过联系我们页面留言。"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="flex flex-col gap-3 lg:col-span-2">
          {homeFaqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.question}
                className="overflow-hidden rounded-card border border-background-200/80 bg-background-50"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-200 hover:bg-background-100/70"
                  >
                    <span className="text-sm font-medium text-foreground-900 md:text-base">
                      {item.question}
                    </span>
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm`}></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <p className="animate-fade-in border-t border-background-200/70 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {item.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>

        <aside className="flex flex-col justify-between rounded-card border border-background-200/80 bg-primary-50 p-6">
          <div>
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-customer-service-2-line text-xl"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
              还有别的疑问？
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              把问题写给我们，编辑团队会在一个工作日内回复。遇到内容有出入，也欢迎直接指出来。
            </p>
          </div>
          <Link
            to="/contact"
            className="mt-6 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-mail-send-line text-base"></i>
            </span>
            去留言反馈
          </Link>
        </aside>
      </div>
    </section>
  );
}